import store from "../storeWire";
import {
    create_project,
    delete_project,
    edit_project,
    fetch_bom_project_detail_with_bom,
    fetch_project_list,
    fetch_single_project
} from "../store/slice/model/BOMProject";
import {useSelector} from "react-redux";

export function useBOMProjectStore() {
    const total_bom = useSelector((state) => state.entities.model_BOMProject.total_bom)
    const bom_project_list = useSelector((state) => state.entities.model_BOMProject.bomProjectList)
    const your_bom_listing = useSelector((state) => state.entities.model_BOMProject.yourBomListing)
    const your_bom_listing_with_project = useSelector((state) => state.entities.model_BOMProject.yourBomListingWithProject)
    let data = {
        total_bom,
        bom_project_list,
        your_bom_listing,
        your_bom_listing_with_project
    };
    let fetch = {
        fetch_project_list: async () => {
            return await store.dispatch(fetch_project_list())
        },
        fetch_bom_project_detail_with_bom: async () => {
            return await store.dispatch(fetch_bom_project_detail_with_bom())
        },
        fetch_single_project: async (params) => {
            return await store.dispatch(fetch_single_project(params))
        },
    };
    let set = {
        create_project: async (params) => {
            return await store.dispatch(create_project(params))
        },
        delete_project: async (params) => {
            return await store.dispatch(delete_project(params))
        },
        edit_project: async (params) => {
            return await store.dispatch(edit_project(params))
        },
    };
    return [data, fetch, set]
}